/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReadConfigObject } from './ReadConfigObject';
import {
    ReadConfigObjectFromJSON,
    ReadConfigObjectFromJSONTyped,
    ReadConfigObjectToJSON,
} from './ReadConfigObject';

/**
 * 
 * @export
 * @interface ReadConfig
 */
export interface ReadConfig {
    /**
     * 
     * @type {{ [key: string]: ReadConfigObject; }}
     * @memberof ReadConfig
     */
    objects: { [key: string]: ReadConfigObject; };
}

/**
 * Check if a given object implements the ReadConfig interface.
 */
export function instanceOfReadConfig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objects" in value;

    return isInstance;
}

export function ReadConfigFromJSON(json: any): ReadConfig {
    return ReadConfigFromJSONTyped(json, false);
}

export function ReadConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objects': (mapValues(json['objects'], ReadConfigObjectFromJSON)),
    };
}

export function ReadConfigToJSON(value?: ReadConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objects': (mapValues(value.objects, ReadConfigObjectToJSON)),
    };
}

